import React from 'react';
import { render } from 'react-dom';
import {parseDataToProps} from "../../../helpers";

const cartCountNodes = document.querySelectorAll('.cart-count');

if (cartCountNodes.length > 0) {
    import(/* webpackChunkName: "CartCount" */ './components/CartCount').then(({ObservingCart: ObservingCart}) => {
        [...cartCountNodes].forEach((node) => render(<ObservingCart {...parseDataToProps(node.dataset)} />, node));
    });
}
